import { render, staticRenderFns } from "./PermissionAssignmentRole.vue?vue&type=template&id=2e678616&scoped=true&"
import script from "./PermissionAssignmentRole.vue?vue&type=script&lang=js&"
export * from "./PermissionAssignmentRole.vue?vue&type=script&lang=js&"
import style0 from "./PermissionAssignmentRole.vue?vue&type=style&index=0&id=2e678616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e678616",
  null
  
)

export default component.exports